import { USER_SEGMENT_ENUM } from 'integration/resources/auth'

import { MultiplierValuesType, Tab } from '../RVCalculators2026.types'

export const rolesGR = [
  'GTE RELAC FINANC I',
  'GTE RELAC FINANC II',
  'GTE RELAC FINANC III (FIN)',
  'ESPEC COML FINANCEIRA I',
  'ESPEC COML FINANCEIRA II',
  'ESPEC COML FINANCEIRA III'
]

export const targets = [
  { id: '0', name: 'Especialista I', value: 1050 }, // Lojas N7
  { id: '1', name: 'Especialista II', value: 1450 }, // Lojas N8
  { id: '2', name: 'Especialista I', value: 1272 }, // CSS N7
  { id: '3', name: 'Especialista II e III', value: 1526 } // CSS N8
]

const lojasTargets = targets.slice(0, 2)

const cssTargets = targets.slice(2, 4)

export const resultsTargets = [
  { id: '0', name: 'Especialista I', value: 2100 }, // Lojas N7
  { id: '1', name: 'Especialista II', value: 2900 }, // Lojas N8
  { id: '2', name: 'Especialista I', value: 2544 }, // CSS N7
  { id: '3', name: 'Especialista II e III', value: 3052 } // CSS N8
]

const lojasResultsTargets = resultsTargets.slice(0, 2)

const cssResultsTargets = resultsTargets.slice(2, 4)

export const getTargetsBySegment = (segment?: USER_SEGMENT_ENUM) => {
  switch (segment) {
    case USER_SEGMENT_ENUM.LEVES:
      return lojasTargets

    case USER_SEGMENT_ENUM.LOJAS:
      return lojasTargets

    case USER_SEGMENT_ENUM.CSS:
      return cssTargets

    default:
      return lojasTargets
  }
}

export const getResultsTargetsBySegment = (segment?: USER_SEGMENT_ENUM) => {
  switch (segment) {
    case USER_SEGMENT_ENUM.LEVES:
      return lojasResultsTargets

    case USER_SEGMENT_ENUM.LOJAS:
      return lojasResultsTargets

    case USER_SEGMENT_ENUM.CSS:
      return cssResultsTargets

    default:
      return lojasResultsTargets
  }
}

export const performanceValues = [0, 5, 15, 30]

export const expensesValues = [-5, -3, -2, 0]

export const chargeGoalValues = [1, 2]

export const multiplierValues: MultiplierValuesType = {
  2: { withInsurance: 1, withoutInsurance: 1 },
  3: { withInsurance: 1.4, withoutInsurance: 1.2 },
  4: { withInsurance: 1.8, withoutInsurance: 1.4 },
  5: { withInsurance: 2.3, withoutInsurance: 1.8 },
  6: { withInsurance: 4.0, withoutInsurance: 4.0 }
}

export const resultMultiplierValues: MultiplierValuesType = {
  0: { withInsurance: 1, withoutInsurance: 1 },
  1: { withInsurance: 1.2, withoutInsurance: 1.1 },
  2: { withInsurance: 1.4, withoutInsurance: 1.2 },
  3: { withInsurance: 2, withoutInsurance: 1.5 },
  4: { withInsurance: 2.8, withoutInsurance: 2 },
  5: { withInsurance: 4, withoutInsurance: 3 }
}

export const indicatorsLines = [
  'Produção',
  'Prestamista',
  'SA',
  'Cobrança',
  'Webmotors',
  'Ecossistema',
  '↳ Base Ativa',
  '↳ +Contas',
  'Total'
]

export const tabsConfig: Tab[] = [
  {
    id: 1,
    title: `Calculadora Bloco de Negócios`,
    subtitle: 'Simule seus ganhos de remuneração variável e compare com sua RV atual',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2026. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  },
  {
    id: 3,
    title: 'Calculadora de Resultados',
    subtitle: 'Subtítulo contextualizando a calculadora.',
    observations: [
      `Este “SIMULADOR” deve ser utilizado para simples estimativas e para esclarecer eventuais pontos sobre o cálculo do programa de RV 2026. Ele não considera eventuais proporcionalidades nem representa critérios oficiais de elegibilidade, apuração e pagamento.`
    ]
  }
]
